"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileApproveAuthenticatorHandler = void 0;
var constants_1 = require("../constants");
var sdk_1 = require("../sdk");
var types_1 = require("../types");
var sendDynatraceEvent_1 = require("../utilities/sendDynatraceEvent");
var Base_1 = require("./Base");
var MobileApproveAuthenticatorHandler = /** @class */ (function (_super) {
    __extends(MobileApproveAuthenticatorHandler, _super);
    // 1
    function MobileApproveAuthenticatorHandler(onScreenUpdate, onScreenLoading, sdkInstance, otpValue, approvalTtl) {
        var _this = _super.call(this, onScreenUpdate, onScreenLoading) || this;
        _this.onScreenUpdate = onScreenUpdate;
        _this.onScreenLoading = onScreenLoading;
        _this.actionContext = null;
        _this.sdkInstance = sdkInstance;
        _this.otpValue = otpValue;
        _this.escapeIntent = null;
        _this.userHasAbandoned = false;
        _this.initTime = new Date();
        var now = new Date();
        now.setSeconds(now.getSeconds() + approvalTtl);
        _this.expirationDate = now;
        return _this;
    }
    // 2
    /* istanbul ignore next */
    MobileApproveAuthenticatorHandler.prototype.setAvailableTargets = function (_targets) {
        // no-op
    };
    // 3
    /* istanbul ignore next */
    MobileApproveAuthenticatorHandler.prototype.setCreatedApprovalInfo = function (_targets, _otp) {
        // no-op
    };
    // 4
    MobileApproveAuthenticatorHandler.prototype.startSession = function (_description, _mode, actionContext, _clientContext) {
        this.actionContext = actionContext;
        (0, sendDynatraceEvent_1.sendDynatraceEvent)("Transmit MobileApprove authenticator presented");
    };
    // This is not part of Transmit SDK, it's here to make the code easier to read
    // and assist in testing
    MobileApproveAuthenticatorHandler.prototype.setEscapeIntent = function (escapeOption) {
        this.escapeIntent = escapeOption;
    };
    /**
     * This is not part of the Transmit SDK, it is used to preemptively respond with
     * the 'timeout' escape
     *
     * ref: CIAM-17726
     */
    MobileApproveAuthenticatorHandler.prototype.checkIsAboutToExpire = function () {
        var now = new Date();
        var deltaInMs = this.expirationDate.getTime() - now.getTime();
        window.t12rLogger.debug({
            message: "checkIsAboutToExpire(): remaining time: ".concat(deltaInMs / 1000, "s"),
        });
        return deltaInMs < constants_1.MOBILE_APPROVE_EXPIRATION_BUFFER;
    };
    // 5
    MobileApproveAuthenticatorHandler.prototype.promiseInput = function () {
        var _this = this;
        return new Promise(function (resolve, _reject) {
            if (_this.userHasAbandoned) {
                _this.sdkInstance.cancelCurrentRunningControlFlow();
                (0, sendDynatraceEvent_1.sendDynatraceEvent)('Transmit MobileApprove authenticator escaped: abandoned');
                return;
            }
            // Check and set the timeout escape if we're within the expiration buffer for this request
            if (_this.checkIsAboutToExpire()) {
                _this.setEscapeIntent(types_1.MobileApproveEscapeIntent.Timeout);
            }
            /**
             * If the user has chosen one of the escapes, we need to resolve the
             * promise on next invoke with that option. This is due to an issue caused
             * when users choose an escape option after the promise was resolved (and
             * during the network request) with the request polling input. Since the
             * promise was already resolved
             * the users action does nothing. So instead we store that escape intent
             * and attempt to act on it on the next invoke. This is the only way to
             * guarantee that each click of an escpae will 100% invoke the action.
             * Unfortunately this results in a delay in the time it takes for the
             * user to see the result of their action. Worst case this can take
             * MOBILE_APPROVE_POLLING_INTERVAL + network request time
             * (~750ms or more) seconds to resolve. During this time we'll show
             * some loading indicator (TBD)
             */
            if (_this.escapeIntent) {
                var escapeOption = _this.actionContext.escapeOptionById(_this.escapeIntent);
                resolve(sdk_1.InputOrControlResponse.createEscapeResponse(escapeOption, null));
                // any escape option that uses this.setEscapeIntent should be captured in Dynatrace by this (refer to MobileApproveEscapeIntent for list)
                (0, sendDynatraceEvent_1.sendDynatraceEvent)("Transmit MobileApprove authenticator escaped: ".concat(JSON.stringify(escapeOption), " ").concat(escapeOption.getId()));
                return;
            }
            setTimeout(function () {
                resolve(sdk_1.InputOrControlResponse.createInputResponse(sdk_1.TargetBasedAuthenticatorInput.createAuthenticatorInput(sdk_1.MobileApproveInputRequestPolling.createRequestPollingInput())));
            }, constants_1.MOBILE_APPROVE_POLLING_INTERVAL);
            _this.onScreenUpdate({
                type: 'MobileApprove',
                payload: {
                    status: 'None',
                    otpValue: _this.otpValue,
                    handleResend: function () {
                        _this.onScreenLoading();
                        _this.setEscapeIntent(types_1.MobileApproveEscapeIntent.Resend);
                    },
                    handleRepick: function () {
                        _this.onScreenLoading();
                        _this.setEscapeIntent(types_1.MobileApproveEscapeIntent.Repick);
                    },
                    handleAbandon: function () {
                        _this.userHasAbandoned = true;
                    },
                    initTime: _this.initTime,
                },
            });
        });
    };
    /* istanbul ignore next */
    MobileApproveAuthenticatorHandler.prototype.setGeneratedOtp = function (_format, _target) {
        // no-op
    };
    /* istanbul ignore next */
    MobileApproveAuthenticatorHandler.prototype.changeSessionModeToRegistrationAfterExpiration = function () {
        // no-op
    };
    MobileApproveAuthenticatorHandler.prototype.promiseRecoveryForError = function (error, _validRecoveries, _defaultRecovery) {
        return new Promise(function (resolve, _reject) {
            // Note: activeScreen state is updated in the usesSession hook
            window.t12rLogger.debug({
                message: [
                    "MobileApprove.promiseRecoveryForError(): ".concat(error.getMessage(), ", code: (").concat(error.getErrorCode(), ")"),
                ],
            });
            resolve(sdk_1.AuthenticationErrorRecovery.Fail);
            (0, sendDynatraceEvent_1.sendDynatraceEvent)("Transmit MobileApprove authenticator failed with error: ".concat(error.getErrorCode(), " - ").concat(error.getMessage()));
        });
    };
    /* istanbul ignore next */
    MobileApproveAuthenticatorHandler.prototype.endSession = function () {
        // no-op
    };
    return MobileApproveAuthenticatorHandler;
}(Base_1.BaseAuthenticatorHandler));
exports.MobileApproveAuthenticatorHandler = MobileApproveAuthenticatorHandler;
//# sourceMappingURL=MobileApprove.js.map